<template>
  <div>
    <page-section bgcolor="bg-gray-50">
      <section-heading pre="Services">What We Provide</section-heading>
      <div>
        <p>
          We provide midwifery clinic services through our clinic on Nipissing
          First Nation, ON and at our satellite site in Powassan as well. Our
          mission is to provide quality midwifery care, support and guidance to
          pregnant people, their families, and communities in a safe and
          culturally appropriate setting open to traditional teachings and
          ceremonies. We honor and incorporate local indigenous (First Nation)
          knowledge in relation to the spiritual, emotional, mental and physical
          experiences of a pregnant person during their childbearing years. We
          endeavor to provide training and mentorship and provide an environment
          conducive to inter-professional development to initiate post-colonial
          and community-based healing and wellness in the area of maternal
          health and well-being.
        </p>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center my-5">
          <div v-for="(item, i) in services_gallery" :key="i">
            <img :src="item" class="rounded-lg shadow-lg overflow-hidden" />
          </div>
        </div>
      </div>
    </page-section>

    <page-section>
      <section-heading pre="Services">What to expect</section-heading>
      <div>
        <dl
          class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:grid-rows-2 md:gap-x-8 md:gap-y-12"
        >
          <div>
            <dt class="text-lg leading-6 font-medium text-gray-900">Medical</dt>
            <dd class="mt-2 text-base text-gray-500">
              A client can expect to have about 12 prenatal visits with a
              midwife before their delivery. Midwives arrange any routine
              prenatal testing, blood tests, ultrasounds, genetic screenings and
              standard laboratory and diagnostic tests that you require and
              accept.
            </dd>
          </div>
          <div>
            <dt class="text-lg leading-6 font-medium text-gray-900">
              Birthing
            </dt>
            <dd class="mt-2 text-base text-gray-500">
              With low risk pregnancies most folks can choose to have their
              birth at home, in clinic, or at the hospital. Midwives in Ontario
              are trained for in hospital and out-of-hospital births, including
              births at home and birth centres.
            </dd>
          </div>
          <div>
            <dt class="text-lg leading-6 font-medium text-gray-900">
              Education
            </dt>
            <dd class="mt-2 text-base text-gray-500">
              Midwives provide support, education, instructions and resources on
              breast/chest-feeding. They provide personal assistance on
              techniques.
            </dd>
          </div>
          <div>
            <dt class="text-lg leading-6 font-medium text-gray-900">Success</dt>
            <dd class="mt-2 text-base text-gray-500">
              Over 90% of midwifery clients have success with
              breast/chest-feeding after six weeks, when compared with the
              provincial average of around 60%.
            </dd>
          </div>
        </dl>
        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-4 text-center mt-5 mb-8"
        >
          <div>
            <img
              src="/images/services1.jpg"
              class="rounded-lg shadow-lg overflow-hidden"
            />
          </div>
          <div>
            <img
              src="/images/services2.jpg"
              class="rounded-lg shadow-lg overflow-hidden"
            />
          </div>
        </div>

        <div class="grid grid-cols-1 mb-5">
          <p>
            KTM exists to deliver sexual and reproductive health care that is
            culturally safe and trauma aware. We are primary health care
            providers who predominantly support Indigenous families as well as
            our neighbors. We provide comprehensive preconception, pregnancy,
            birth and postpartum care, including expanded midwifery services
            based on community needs.
          </p>
        </div>
      </div>
    </page-section>
  </div>
</template>
<script>
import SectionHeading from "@/components/SectionHeading";
import PageSection from "@/components/PageSection";

export default {
  components: {
    SectionHeading,
    PageSection,
  },
  data() {
    return {
      services_gallery: [
        "/images/services3.jpg",
        "/images/services4.jpg",
        "/images/services5.jpg",
      ],
    };
  },
};
</script>